export default {
  "current-color": "currentColor",

  "color-0": "#71c0ff",
  "color-1": "#42a5f5",
  "color-2": "#40b771",
  "color-3": "#ef5350",
  "color-4": "#2a2e30",
  "color-5": "#4e5360",
  "color-6": "#707277",
  "color-7": "#8e929d",
  "color-8": "#cbcdd4",
  "color-9": "#edeef1",
  "color-10": "#fff",

  "color-helper-1": "#FFD54F",
  "color-helper-2": "#5765A2",
  "color-helper-3": "#A57C3A",
  "color-helper-4": "#D48CDA",
  "color-helper-5": "#FFF8E1",
  "color-helper-6": "#ffc400",
};
